export default __webpack_public_path__ + "static/media/add.ee696f13.svg";